export default __webpack_public_path__ + "static/media/error_subscribedfeeds.c14e3e07.svg";